//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.ShipDesign.ProfileSystemBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../Features/Features.ShipDesign.EndCutBuilder.js";
import "../Features/Features.ShipDesign.OrientationDefinitionBuilder.js";
import "../Features/Features.ShipDesign.ShipNamesBuilder.js";
import "../Features/Features.ShipDesign.StiffenerStockBuilder.js";
import "../Weld/Weld.CharacteristicsBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/Features.js";
import "../no/Weld.js";
let d=[[[0,"BuildSolid",1,0],[0,"CreateSeamsAtKnuckles",1,0],[1,"EdgeOffset",0,"Expression",0],[1,"Edges",0,"Section",0],[0,"EndCutEnd",1,0],[0,"EndCutStart",1,0],[1,"EndEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[0,"KnuckleLocationTolerance",1,0],[1,"Offset",0,"Expression",0],[1,"OrientationAngle",0,"Expression",0],[1,"OrientationDefinitionBuilder",0,"Features.ShipDesign.OrientationDefinitionBuilder",0],[0,"OrientationMethod",1,0],[0,"OrientationVector",1,"Direction",0],[0,"Reverse",1,0],[0,"ReverseAttachmentDirection",1,0],[1,"ShipNames",0,"Features.ShipDesign.ShipNamesBuilder",0],[1,"StartEndCut",0,"Features.ShipDesign.EndCutBuilder",0],[1,"StockData",0,"Features.ShipDesign.StiffenerStockBuilder",0],[0,"Type",1,0],[1,"Weld",0,"Weld.CharacteristicsBuilder",0]],[],[]];
SPLM.Features.ShipDesign.EdgeReinforcementBuilder = class extends SPLM.Features.ShipDesign.ProfileSystemBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.EdgeReinforcementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.EdgeReinforcementBuilder.Types = Object.freeze({
    "OnEdge" : "OnEdge", "OnFace" : "OnFace"});

SPLM.Features.ShipDesign.EdgeReinforcementBuilder.OrientationMethods = Object.freeze({
    "FaceNormal" : "FaceNormal", "Vector" : "Vector"});

SPLM.Features.ShipDesign.EdgeReinforcementBuilder.EndCutTypes = Object.freeze({
    "Connected" : "Connected", "FlangeFree" : "FlangeFree", "Sniped" : "Sniped", "SnipedSquare" : "SnipedSquare", "None" : "None"});

export default SPLM;